import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Lock } from "lucide-react";

import { CommercialFooter } from "../components/layout/commercial-footer";

export function CommercialArea() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch("/api/check_auth.php");
        const data = await response.json();
        
        if (data.authenticated && (data.role === 'commercial' || data.role === 'admin')) {
          setIsAuthenticated(true);
        } else {
          // If logged in but not commercial, or not logged in
          navigate("/area-commerciale/login");
        }
      } catch (err) {
        console.error(err);
        navigate("/area-commerciale/login");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await fetch("/api/logout.php");
      navigate("/area-commerciale/login");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  if (loading) return <div className="text-center py-20 text-brand-primary">Caricamento...</div>;

  if (!isAuthenticated) return null;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12">
        {/* Header with Logo */}
        <div className="w-full max-w-4xl px-4 flex justify-end mb-8">
          <Button onClick={handleLogout} variant="outline" size="sm">Esci</Button>
        </div>

        <div className="flex flex-col items-center mb-12">
          <img src="/images/logo-puglialife.png" alt="Puglia Life" className="h-24 mb-6" />
          <h1 className="text-3xl md:text-4xl font-bold text-[#004080] uppercase tracking-wider text-center">
            AREA COMMERCIALE
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl px-4">
          {/* Modulo Consegne - Blue */}
          <Button 
            className="h-20 text-lg font-bold bg-[#004080] hover:bg-[#003366] text-white shadow-lg uppercase w-full md:col-span-1"
            onClick={() => navigate("/area-commerciale/modulo-consegne")}
          >
            MODULO CONSEGNE APPARECCHIATURE
          </Button>

          {/* Database Consegne - Green */}
          <Button 
            className="h-20 text-lg font-bold bg-[#8cc63f] hover:bg-[#7ab035] text-white shadow-lg uppercase w-full md:col-span-1"
            onClick={() => window.open("https://puglialifesrl.it/database-consegne", "_blank")}
          >
            DATA BASE CONSEGNE APPARECCHIATURE
          </Button>

          {/* Preventivi - Green (Centered in next row if odd, or just listing) */}
          <div className="md:col-span-2 flex justify-center">
               <Button 
                className="h-20 text-lg font-bold bg-[#8cc63f] hover:bg-[#7ab035] text-white shadow-lg uppercase w-full md:w-1/2"
                onClick={() => window.open("https://puglialifesrl.it/preventivi", "_blank")}
              >
                PREVENTIVI
              </Button>
          </div>
        </div>
      </div>
      <CommercialFooter />
    </div>
  );
}
